import React, { useEffect } from "react"
import { NewAbstractSelectField } from "./_NewAbstractSelectField"

type ISimpleOption<T> = { label: string; value: T }

type IProps<Key extends string> = {
  options: ISimpleOption<Key>[] | readonly ISimpleOption<Key>[]
  value: Key | null | undefined
  label?: string
  disabled?: boolean
  showRequiredStar?: boolean
  error?: string
  noSearch?: boolean
  placeholder?: string
} & (
  | {
      isClearable: true
      onChange(opt: ISimpleOption<Key> | null): void
    }
  | {
      isClearable?: false
      onChange(opt: ISimpleOption<Key>): void
    }
)

export function NewSimpleSelectField<Key extends string = string>({
  options,
  value,
  onChange,
  label,
  disabled,
  isClearable,
  showRequiredStar,
  error,
  noSearch,
  placeholder,
}: IProps<Key>) {
  const [optionLengthKey, setOptionLengthKey] = React.useState(1)

  useEffect(() => {
    setOptionLengthKey(optionLengthKey + 1)
  }, [JSON.stringify(options)])

  return (
    <NewAbstractSelectField<ISimpleOption<Key>>
      key={optionLengthKey}
      showRequiredStar={showRequiredStar}
      error={error}
      options={options}
      keyExtractor={opt => opt.value}
      renderOption={opt => opt.label}
      filterOption={(opt, query) => opt.label.toLowerCase().includes(query.toLowerCase())}
      onChange={onChange}
      value={value}
      label={label}
      disabled={disabled}
      isClearable={isClearable}
      noSearch={noSearch}
      placeholder={placeholder}
    />
  )
}
